module.exports = __webpack_public_path__ + "img/shipo-map-poi-new.fe24dea9.svg";